import styled from "styled-components";

export const StyledMain = styled.main`
	width: 100%;

	.gallery_container {
		border-radius: 10px;
		border-radius: 10px;

		background-color: var(--green50);
		border: 2px solid black;
		box-shadow: 0px 5px 22px -6px rgba(0, 0, 0, 0.75);
		max-width: 1050px;
		width: 100%;
		margin: 30px auto;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		gap: 20px;
		padding: 20px 20px 50px 20px;

		@media (max-width: 600px) {
			width: 95%;
		}
	}

	header {
		width: 100%;

		justify-content: space-between;
		display: flex;
	}

	ul {
		width: 100%;
		display: flex;
		flex-flow: row wrap;
		justify-content: flex-start;
		gap: 20px;
	}

	@media (max-width: 600px) {
		header {
			flex-direction: column;
			margin-top: 20px;
			gap: 15px;

			h1 {
				font-size: 30px;
			}
		}
	}
	.gallery_title {
		margin-top: 40px;
		font-size: 30px;
		text-shadow: var(--textShadowBlack);
		color: var(--orange);
	}
`;
